import { Form, Typography, Input } from 'antd';
import textAreaCharacterCount from '../TextAreaCharacterCount/TextAreaCharacterCount';
import { sanitizeInput } from '../../utilities/commonFunctions';

const { Text } = Typography;
const { TextArea } = Input;

const DescriptionFormItem = () => {
  const [form] = Form.useForm();

  const handleChange = e => {
    const sanitizedValue = sanitizeInput(e.target.value);
    form.setFieldsValue({ description: sanitizedValue });
  };

  return (
    <Form.Item
      name="description"
      className="message-form-item-modal"
      rules={[
        ({ getFieldValue }) => ({
          validator(_, value) {
            if (getFieldValue('callType') === 'Genuine call' && !value) {
              return Promise.reject(new Error('Please enter description'));
            }
            return Promise.resolve();
          },
        }),
      ]}
      label={
        <Text strong style={{ marginTop: '4px' }}>
          Description
        </Text>
      }
    >
      <TextArea
        autoSize
        placeholder="Type your message here&#10;e.g: sample"
        rows={4}
        maxLength={500}
        count={{
          max: 500,
          show: textAreaCharacterCount,
        }}
        onChange={handleChange}
      />
    </Form.Item>
  );
};

export default DescriptionFormItem;
